module.exports = __webpack_public_path__ + "img/schema.470cb969.png";